<template>
	<div>
		<q-dialog v-model="modal_police" position="bottom" persistent>
			<q-card>
				<q-toolbar>
					<q-toolbar-title>{{ $t('cookies_policy') }}</q-toolbar-title>
					<q-btn flat round dense icon="fal fa-times" @click="closePolicy()" />
				</q-toolbar>
				<q-card-section class="q-pt-none">
					<p class="q-mb-none">{{ $t('cookies_policy_information') }}</p>
					<p
						class="cursor-pointer text-weight-bold q-mb-none"
						@click="$router.push({ name: 'cookies_policy' })"
					>
						{{ $t('to_understand_why_we_use_cookies') }}
					</p>
				</q-card-section>
				<q-card-actions align="right">
					<q-btn no-caps color="primary" @click="setCookies()" :label="$t('accept')" />
					<q-btn
						v-if="cookies_type == 'optional'"
						no-caps
						color="grey-10"
						:label="$t('set_cookies')"
						@click="openPreferences()"
					/>
				</q-card-actions>
			</q-card>
		</q-dialog>

		<q-dialog v-model="modal_police_preferences">
			<q-card>
				<q-card-section>
					<div class="text-h6">{{ $t('cookies_policy') }}</div>
				</q-card-section>

				<q-card-section class="q-pt-none">
					<q-banner class="shadow-1 q-mb-md">
						<p class="text-caption q-mb-none">{{ $t('cookies_policy_information') }}</p>
						<p
							class="text-caption cursor-pointer text-weight-bold"
							@click="$router.push({ name: 'cookies_policy' })"
						>
							{{ $t('to_understand_why_we_use_cookies') }}
						</p>
					</q-banner>
					<q-banner class="shadow-1 q-mb-md">
						<p class="text-weight-bold q-ma-none q-mb-sm">
							{{ $t('cookies_fonctionnels') }}
						</p>
						<p class="text-caption">{{ $t('cookies_fonctionnels_information') }}</p>
					</q-banner>
					<q-banner class="shadow-1 q-mb-md">
						<div>
							<p class="text-weight-bold q-ma-none q-mb-sm">
								{{ $t('cookies_custom') }}
							</p>
							<p class="text-caption q-mb-none">
								{{ $t('cookies_custom_information') }}
							</p>
						</div>
						<div class="text-right">
							<q-toggle v-model="toggle" size="lg" />
						</div>
					</q-banner>
				</q-card-section>

				<q-card-actions align="right" class="text-primary">
					<q-btn no-caps color="primary" :label="$t('accept')" @click="setOptionalCookies()" />
					<q-btn no-caps color="negative" :label="$t('refuse')" @click="closeOptions" />
				</q-card-actions>
			</q-card>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'AcceptCookiesPolicy',

	i18nOptions: { namespaces: ['custom', 'common'] },

	data() {
		return {
			toggle: false,
		}
	},

	computed: {
		...mapGetters({
			policy_modal: 'cookies_policy/policy_modal',
			policy_preferences_modal: 'cookies_policy/policy_preferences_modal',
			accept_cookies: 'cookies_policy/accept_cookies',
			cookies_type: 'params/cookies_type',
		}),

		modal_police: {
			get() {
				return this.policy_modal
			},
			set(value) {
				this.$store.dispatch('cookies_policy/SET_POLICY', [value])
			},
		},

		modal_police_preferences: {
			get() {
				return this.policy_preferences_modal
			},
			set(value) {
				this.$store.dispatch('cookies_policy/SET_POLICY_PREFERENCES', [value])
			},
		},
	},

	methods: {
		closePolicy() {
			this.$store.dispatch('cookies_policy/SET_POLICY', [false])
		},

		openPreferences() {
			this.$store.dispatch('cookies_policy/SET_POLICY', [false])
			this.$store.dispatch('cookies_policy/SET_POLICY_PREFERENCES', [true])
		},

		closeOptions() {
			this.$store.dispatch('cookies_policy/SET_POLICY', [true])
			this.$store.dispatch('cookies_policy/SET_POLICY_PREFERENCES', [false])
		},

		setCookies() {
			this.$store.dispatch('cookies_policy/SET_COOKIES', [true])
			this.$store.dispatch('cookies_policy/SET_POLICY_PREFERENCES', [false])
			this.$store.dispatch('cookies_policy/SET_POLICY', [false])
		},

		setOptionalCookies() {
			if (this.toggle) {
				this.setCookies()
			} else {
				this.$store.dispatch('cookies_policy/SET_OPTIONAL_COOKIES', [true])
				this.$store.dispatch('cookies_policy/SET_POLICY_PREFERENCES', [false])
				this.$store.dispatch('cookies_policy/SET_POLICY', [false])
			}
		},
	},

	created() {
		if (this.cookies_type == 'onetrust' || this.cookies_type == 'cookiereports') {
			this.$store.dispatch('cookies_policy/SET_POLICY', [false])
		} else if (this.$q.platform.is.mobile) {
			this.setCookies()
		} else {
			if (
				!this.accept_cookies &&
				!this.policy_modal &&
				(this.cookies_type == 'default' || this.cookies_type == 'optional' || this.cookies_type == undefined)
			) {
				this.$store.dispatch('cookies_policy/SET_POLICY', [true])
			}
		}
	},
}
</script>

<style></style>
